module.exports = __webpack_public_path__ + "static/media/b.49c4a1e4.jpg";